import React from "react";
import styled from "styled-components";
import CodepenWebType from "./IndividualProjects/CodepenWebType";
import Sights from "./IndividualProjects/Sights";
import Royalty from "./IndividualProjects/Royalty";
import TimeCapsule from "./IndividualProjects/TimeCapsule";
import Nga from "./IndividualProjects/Nga";
import Mui from "./IndividualProjects/Mui";
import OnTheWrist from "./IndividualProjects/OnTheWrist";
import Capture from "./IndividualProjects/Capture";
import BladeRunner2049 from "./IndividualProjects/Bladerunner2049";
import MobileBanking from "./IndividualProjects/MobileBanking";
import Served from "./IndividualProjects/Served";
import MYOBInvoices from "./IndividualProjects/MYOBInvoices";
import IOS14 from "./IndividualProjects/IOS14";
import Sensei from "./IndividualProjects/Sensei";
import Feelix from "./IndividualProjects/Feelix";
import UpVote from "./IndividualProjects/UpVote";
import Voya from "./IndividualProjects/Voya";
import OpenNote from "./IndividualProjects/OpenNote";
import BoneCarving from "./IndividualProjects/BoneCarving";
import VirtualCard from "./IndividualProjects/VirtualCard";
import Guides from "./IndividualProjects/Guides";
import Outcomes from "./IndividualProjects/outcomes";
import OrgAgent from "./IndividualProjects/OrgAgent";
import Redactd from "./IndividualProjects/Redactd";
import Dumpty from "./IndividualProjects/Dumpty";

const ProjectWrapper = styled.article`
  margin-bottom: 0;
`;

const Main = () => {
  return (
    <ProjectWrapper>
      <Redactd />
      <Mui />
      <Dumpty />
      <Voya />
      <OpenNote />
      <UpVote />
      <OrgAgent />
      <Sensei />
      <Outcomes />
      <VirtualCard />
      <Guides />
      <MYOBInvoices />
      <Feelix />
      <Capture />
      <MobileBanking />
      <OnTheWrist />
      <CodepenWebType />
      <Served />
      <Sights />
      <Royalty />
      <Nga />
      <BoneCarving />
      <IOS14 />
      <BladeRunner2049 />
      <TimeCapsule />
    </ProjectWrapper>
  );
};

export default Main;
